export const shadow = {
  "Level 1": "0px 0.25rem 0.5rem rgba(0, 0, 0, 0.08)",
  "Level 2": "0px 0.5rem 1.5rem rgba(0, 0, 0, 0.16)",
  "Level 3": "0px 1rem 2rem rgba(0, 0, 0, 0.16)",
  "Level 4": "0px 1rem 3rem rgba(0, 0, 0, 0.24)",
  Header: "inset 0px -1px 0px #e6e6e6",
} as const;
